export default [
    {
        name: 'cadastro-logradouro-tipo',
        path: 'logradouro-tipo',
        redirect: 'logradouro-tipo/index',
        component: () => import(/* webpackChunkName: 'cadastro-logradouro-tipo' */ '@/views/cadastro/logradouro-tipo/Index'),
        children: [
            {
                meta: {title: 'Lista de tipos de logradouro'},
                name: 'cadastro-logradouro-tipo-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-logradouro-tipo' */ '@/views/cadastro/logradouro-tipo/List.vue'),
            },
        ],
    },
]